import React from "react"

class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error("Error de render no controlado", {
      message: error?.message,
      componentStack: info?.componentStack,
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="error-boundary" role="alert">
          <h1>No pudimos mostrar esta página</h1>
          <p>
            Recarga la página para intentarlo de nuevo. Si el problema continúa,
            vuelve al inicio.
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Recargar
          </button>
          <a href="/">Volver al inicio</a>
        </main>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
